import React from 'react';

import './PostAuth.scss';

function PostAuth(props) {
    return (
        <div
            id="post-auth"
            aria-label="Main"
        >
            {props.children}
        </div>
    );
}

export default PostAuth;
